module.exports = __webpack_public_path__ + "static/compass-logo-65e40f81a1cb3393cd1087487ff1992c.png";